import React from "react";

const RefreshButton = ({ color, onClick }) => {
  return (
    <button
      className="btn btn-primary refresh-btn"
      style={{
        float: "right",
        margin: "0px",
        height: "50px",
        width: "50px",
        borderRadius: "50%",
        backgroundColor: color,

        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <span
        className="glyphicon glyphicon-refresh"
        style={{ fontSize: "22px" }}
      ></span>{" "}
    </button>
  );
};

export default RefreshButton;
